import { z } from 'zod';
import { Id, IsoDateTime, Currency } from './common.js';

export const OrderStatus = z.enum([
  'pending',
  'confirmed',
  'preparing',
  'dispatched',
  'delivered',
  'cancelled',
  'returned',
]);
export type OrderStatus = z.infer<typeof OrderStatus>;

export const OrderPaymentMethod = z.enum(['cod', 'online', 'transfer', 'other']);
export const OrderSource = z.enum(['ai', 'merchant_manual', 'platform', 'customer_self']);

export const OrderItem = z.object({
  product_id: Id,
  variant_id: Id.nullable(),
  external_product_id: z.string().nullable(),
  title: z.string(),
  quantity: z.number().int().positive(),
  unit_price_cents: z.number().int().nonnegative(),
  currency: Currency,
});

export const Order = z.object({
  order_id: Id,
  merchant_id: Id,
  external_order_id: z.string().nullable(),
  customer_id: Id,
  conversation_id: Id.nullable(),
  source: OrderSource,
  payment_method: OrderPaymentMethod,
  status: OrderStatus,
  customer_name: z.string(),
  customer_phone: z.string(),
  delivery_address: z.string().nullable(),
  items: z.array(OrderItem),
  subtotal_cents: z.number().int().nonnegative(),
  delivery_fee_cents: z.number().int().nonnegative().default(0),
  discount_cents: z.number().int().nonnegative().default(0),
  total_cents: z.number().int().nonnegative(),
  currency: Currency,
  notes: z.string().default(''),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type Order = z.infer<typeof Order>;
